import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Pagination(theme: Theme) {
  return {
    MuiPagination: {
      defaultProps: {
        color: 'standard' as const,
      },

      styleOverrides: {
        root: {
          '& .MuiPaginationItem-root': {
            fontVariantNumeric: 'tabular-nums',
            '&:hover': {
              backgroundColor: theme.palette.background.neutral,
            },
            // Current page is a state, so it is ink — not the navy action wash
            // the old color="primary" default painted it with.
            '&.Mui-selected': {
              fontWeight: theme.typography.fontWeightMedium,
              backgroundColor: theme.palette.text.primary,
              color: theme.palette.background.paper,
              '&:hover': {
                backgroundColor: theme.palette.text.primary,
              },
            },
          },
        },
      },
    },
  }
}
